<template>
  <Dialog class="p-dialog-share" v-model:visible="show" :header="header" :dismissableMask="true" :modal="true" :draggable="false" :breakpoints="{'600px': '75vw', '640px': '90vw'}" :style="{width: '600px'}">
    <div>
      <div v-if="authenticated && showSigninInfo">
        <span :class="appendSehattyClass('d-block mt-3 mt-sm-5 text-center')">تسجيل الدخول سيمكنك من تتبع أثرك</span>
        <div class="d-flex justify-content-center mt-3">
          <router-link :to="'/sign-in?tab=0'" v-if="!this.isSehatty">
            <Button :class="appendSehattyClass('p-button p-button-rounded p-button-primary px-5 mx-auto')" label="تسجيل الدخول" data-cy="sign-in-btn" />
          </router-link>
          <a :href="'/sign-in?tab=0'" target="_blank" v-else>
            <Button :class="appendSehattyClass('p-button p-button-rounded p-button-primary px-5 mx-auto')" label="تسجيل الدخول" data-cy="sign-in-btn" />
          </a>
          
        </div>
      </div>
      <span v-else-if="!authenticated && showSigninInfo"
            class='d-block mt-3 mt-sm-5 text-center'>
        يمكنك تتبع مبلغ التبرعات من خلال مشاركة هذا الرابط
      </span>
      <span class="input-wrapper mt-4">
      <div>
        <InputText type="text" :value="sharableLink" :placeholder="isGeneratingLink ? '...جاري إنشاء الرابط' : ''" disabled ref="shareInput" data-cy="copy-link-input"/>
        <Button :class="[appendSehattyClass('p-input-text__icon-wrapper'), { 'endowment-mode': isEndowmentMode }]" @click="copyLink" :disabled="isGeneratingLink" data-cy="copy-link-btn">
          <i class="pi pi-copy" />
        </Button>
      </div>
    </span>
      <div class="social-media-buttons d-flex justify-content-center mt-4">
        <a class="text-decoration-none" :href="whatsappLink" target="_blank">
          <Button icon="pi pi-whatsapp"
            data-cy="whatsapp-share-btn"
            class="p-button-rounded button-info social-media-buttons__button mx-2 social-media-buttons--whatsapp"
            icon-class="h2 mb-0"
            />
        </a>
        <a class="text-decoration-none" :href="twitterLink" target="_blank">
          <Button icon="pi pi-twitter"
            data-cy="twitter-share-btn"
            class="p-button-rounded button-info social-media-buttons__button mx-2  social-media-buttons--twitter"
            icon-class="h2 mb-0"
            />
        </a>
        <a class="text-decoration-none" :href="facebookLink" target="_blank">
          <Button icon="pi pi-facebook"
            data-cy="facebook-share-btn"
            class="p-button-rounded button-info social-media-buttons__button mx-2 social-media-buttons--facebook"
            icon-class="h2 mb-0"
            />
        </a>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import { appendSehattyClass } from "@/helpers/helpers";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    header: {
      type: String,
      required: false,
    },
    authenticated: {
      type: Boolean,
      required: true,
      default: false
    },
    showSigninInfo: {
      type: Boolean,
      required: true,
      default: true
    },
    isGeneratingLink: {
      type: Boolean,
      default: false,
    },
    sharableLink: {
      type: String,
      required: true
    },
    facebookLink: {
      type: String,
      required: true,
    },
    twitterLink: {
      type: String,
      required: true,
    },
    whatsappLink: {
      type: String,
      required: true,
    },
    isEndowmentMode: {
      type: Boolean,
      default: false,
    },
  },
  components: { Dialog },
  emits: ["close", "copy"],
  methods: {
    appendSehattyClass,
    copyLink() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.sharableLink).then(() => {
          this.$toast.add({
            severity: "success",
            detail: "تم نسخ الرابط بنجاح",
            life: 2000,
          });
        }, () => {
          this.$toast.add({
            severity: "error",
            detail: "فشل نسخ الرابط",
            life: 2000,
          });
        });
      } else {
        const input = this.$refs.shareInput.$el;
        input.disabled = false;
        input.select();
        document.execCommand("copy");
        input.disabled = true;
        window.getSelection().removeAllRanges();
        this.$toast.add({
          severity: "success",
          detail: "تم نسخ الرابط بنجاح",
          life: 2000,
        });
      }
    },
  },
  computed: {
    isSehatty() {
      return this.$store.getters.isSehattyPage;
    },
    show: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit('close')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
.sehatty{
  color: $color-sehatty-gray;
}
.p-button.p-button-primary
{
  &.sehatty{
  background-color: $color-sehatty-stroke;
  color: $color-primary-sehatty;
  border-color: $color-sehatty-stroke;
  }
}
.p-input-text__icon-wrapper {
  &.sehatty {
      background-color: $color-primary-sehatty;
      color: $color-primary-background-sehatty;
  }
  &.endowment-mode {
      background-color: #007F5C !important;
      border-color: #007F5C !important;
      
      &:focus,
      &:active,
      &:hover {
        background-color: darken(#007F5C, 5%) !important;
        border-color: darken(#007F5C, 5%) !important;
        box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #007F5C !important;
      }
  }
}
.social-media-buttons {
  &__button {
    width: 66px !important;
    height: 66px !important;
  }
  &--whatsapp {
    background-color: $color-whatsapp-green !important;
    border-color: $color-whatsapp-green !important;
    &:hover {
      border-color: $color-whatsapp-green-hover !important;
      background-color: $color-whatsapp-green-hover !important;
    }
  }
  &--twitter {
    background-color: $color-twitter-blue !important;
    border-color: $color-twitter-blue !important;
    &:hover {
      border-color: $color-twitter-blue-hover !important;
      background-color: $color-twitter-blue-hover !important;
    }
  }
  &--facebook {
    background-color: $color-facebook-blue !important;
    border-color: $color-facebook-blue !important;
    &:hover {
      border-color: $color-facebook-blue-hover !important;
      background-color: $color-facebook-blue-hover !important;
    }
  }
}
</style>
